export const HeaderData = [
  {
    id: 1,
    submenu: true,
    title: "equipment",
    handle: "/equipment",
    sub: [
      {
        title: "cat",
        image: "https://www.barloworld.mn/images/slider/2016-09-20-10-04-58wae_Unknown.jpeg",
        handle: "/equipment/cat/",
      },
      {
        title: "sem",
        image: "https://www.barloworld.mn/images/menu/59e412dc6ac37_AD45B_UG_Haulage_Web.jpg",
        handle: "/equipment/sem/",
      },
      {
        title: "generator",
        image: "https://www.barloworld.mn/images/slider/2016-09-20-10-06-03wae_Unknown.jpeg",
        handle: "/equipment/generator/",
      },
      {
        title: "rent",
        image: "https://www.barloworld.mn/images/slider/2016-09-20-10-06-03wae_Unknown.jpeg",
        handle: "/rent",
      },
      {
        title: "other",
        image: "https://www.barloworld.mn/images/slider/2016-09-20-10-06-03wae_Unknown.jpeg",
        handle: "/equipment/other/",
      },
    ],
  },
  {
    id: 4,
    title: "parts",
    handle: "/parts",
    submenu: true,
    sub: [
      {
        title: "online",
        handle: "https://parts.cat.com/en/catcorp",
      },
      {
        title: "filters",
        handle: "/parts/filters",
      },
      {
        title: "undercarriage",
        handle: "/parts/undercarriage",
      },
      {
        title: "ground",
        handle: "/parts/ground",
      },
      {
        title: "drive",
        handle: "/parts/drive",
      },
      {
        title: "engine",
        handle: "/parts/engine",
      },
    ],
  },
  {
    id: 6,
    submenu: true,
    title: "service",
    handle: "/service",
    sub: [
      {
        title: "component",
        handle: "/service/component",
      },
      {
        title: "machine",
        handle: "/service/machine",
      },
      {
        title: "main",
        handle: "/service/main",
      },
      {
        title: "field",
        handle: "/service/field",
      },
      {
        title: "repair",
        handle: "/service/repair",
      },
      {
        title: "cva",
        handle: "/service/cva",
      },
    ],
  },
  {
    id: 5,
    title: "technology",
    describe: "dtechnology",
    handle: "/technology",
    submenu: true,
    sub: [
      {
        title: "sos",
        handle: "/technology/sos",
      },
      {
        title: "miningt",
        handle: "/technology/miningt",
      },
      {
        title: "trimble",
        handle: "/technology/trimble",
      },
      {
        title: "metro",
        handle: "/technology/metro",
      },
    ],
  },
  {
    id: 7,
    title: "specials",
    handle: "/deals-specials",
    submenu: false,
    sub: [],
  },
  {
    id: 8,
    title: "hr",
    handle: "/careers",
    submenu: true,
    sub: [
      {
        title: "why_us",
        handle: "/careers",
      },
      {
        title: "career",
        handle: "/jobs",
      },
    ],
  },
  {
    id: 9,
    title: "news",
    handle: "/news",
    submenu: true,
    sub: [
      {
        title: "news",
        handle: "/news",
      },
      {
        title: "magazine",
        handle: "/magazine",
      },
    ],
  },
  {
    id: 10,
    title: "about",
    handle: "/about",
    submenu: true,
    sub: [
      {
        title: "board",
        handle: "/management",
      },
      {
        title: "testimonials",
        handle: "/testimonials",
      },
      {
        title: "oneteamonebarloworld",
        handle: "/bbs",
      },
      {
        title: "catmerchandisestore",
        handle: "https://www.facebook.com/BarloCatMerchandiseStore",
      },
    ],
  },
];
